import { render, staticRenderFns } from "./ufc-group-schedule-row.vue?vue&type=template&id=9ffefc1a&scoped=true&"
import script from "./ufc-group-schedule-row.vue?vue&type=script&lang=js&"
export * from "./ufc-group-schedule-row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ffefc1a",
  null
  
)

export default component.exports